import {
  FeatureFlagsProviderProps,
  LDUserInterface,
} from '../../definitions/interfaces';
import {
  LD_CLIENT_SIDE_ID,
  LD_OPTIONS,
  LD_REACT_OPTIONS,
} from '../../utils/constants';

import { LDProvider } from 'launchdarkly-react-client-sdk';
import { RenderIfFlagsExist } from '../RenderIfFlagsExist';
import { useUser } from '@project44/ui-utils';

export const FeatureFlagsProvider = (props: FeatureFlagsProviderProps) => {
  const user = useUser({ skipRedirectOn401: true });
  const userData = user.data;

  if (user.isLoading) {
    return props.loadingComponent;
  } else {
    const ldUser: LDUserInterface = userData
      ? {
          custom: {
            currentDateTime: global.Date.now(),
            companyName: userData.companyName,
            tenantId: userData.tenantId,
            tenantUuid: userData.tenantUuid,
          },
          email: userData.username.toLowerCase(),
          key: `${userData.id}`,
          name: userData.getFullName(),
        }
      : {
          custom: {
            currentDateTime: global.Date.now(),
          },
          key: 'logged-out-anonymous',
        };

    return (
      <LDProvider
        clientSideID={LD_CLIENT_SIDE_ID}
        options={LD_OPTIONS}
        reactOptions={LD_REACT_OPTIONS}
        user={ldUser}
      >
        <RenderIfFlagsExist loadingComponent={props.loadingComponent}>
          {props.children}
        </RenderIfFlagsExist>
      </LDProvider>
    );
  }
};
